var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsCreate',{attrs:{"hasSequence":"","label":_vm.label,"fields":_vm.fields,"modelName":_vm.modelName,"primary":_vm.pageSetting.primary,"secondary":_vm.pageSetting.secondary}})}
var staticRenderFns = []

export { render, staticRenderFns }